const LiveActionTypes = {
  SET_AUTO_REFRESH: "live/SET_AUTO_REFRESH",
  SET_INITIALIZED: "live/SET_INITIALIZED",
  SET_LOADING: "live/SET_LOADING",
  SET_MAP_INFOS: "live/SET_MAP_INFOS",
  SET_SELECTED_LAYERS: "live/SET_SELECTED_LAYERS",
  SET_FILTER: "live/SET_FILTER",
  SET_FILTERS: "live/SET_FILTERS",
  SET_FLOW_DETAILS_STATS: "live/SET_FLOW_DETAILS_STATS",
  SET_FLOW_GENERAL_STATS: "live/SET_FLOW_GENERAL_STATS",
  SET_PARK_DETAILS_STATS: "live/SET_PARK_DETAILS_STATS",
  SET_PEDESTRIAN_DETAILS_STATS: "live/SET_PEDESTRIAN_DETAILS_STATS",
  SET_AVAILABLE_PARKING_LIST: "live/SET_AVAILABLE_PARKING_LIST",
  SET_PARKED_CARS_LIST: "live/SET_PARKED_CARS_LIST",
  SET_ALERT_EVENTS: "live/SET_ALERT_EVENTS",
  SET_ALERT_MODAL_POSITION: "live/SET_ALERT_MODAL_POSITION",
};

export default LiveActionTypes;
